import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row row-content mb-4" }
const _hoisted_3 = { class: "row row-layout mb-3" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "row row-image mb-4" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12" })
  ])
], -1)
const _hoisted_8 = { class: "row row-button" }
const _hoisted_9 = { class: "col-12 mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_InputTextEditor, {
              modelValue: _ctx.contentBlock.content.nl,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.content.nl) = $event)),
                _ctx.onChange
              ],
              label: _ctx.$t('content'),
              name: "content",
              class: "col-12",
              errors: _ctx.errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.contentBlock.layout_code,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.layout_code) = $event)),
                  _ctx.onChange
                ],
                options: _ctx.enumLayoutCode,
                label: _ctx.$t('layout'),
                name: "layout",
                selectText: _ctx.$t('selectText'),
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "selectText", "errors"])
            ])
          ]),
          _createVNode(_component_Subtitle, {
            title: _ctx.$t('image'),
            mb: "3"
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputImage, {
                "onUpdate:modelValue": _ctx.setImageKey,
                onImageCleared: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setImageKey(null))),
                modelValue: _ctx.existingDocumentKey,
                typeCode: _ctx.docType,
                module: _ctx.DpModuleEnum.CMS,
                id: "file-input-image"
              }, null, 8, ["onUpdate:modelValue", "modelValue", "typeCode", "module"])
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_InputCheckboxBoolean, {
                modelValue: _ctx.useButton,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.useButton) = $event)),
                  _ctx.onChange
                ],
                label: _ctx.$t('useButton'),
                name: "useButton",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
            ]),
            (_ctx.useButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.contentBlock.button.button_text.nl,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('buttonText'),
                    name: "buttonText",
                    rules: "max:100",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"]),
                  _createVNode(_component_PageLinkPicker, {
                    payload: _ctx.pageLinkButtonPayload,
                    "enable-no-link": false,
                    errors: _ctx.errors,
                    onChanged: _ctx.onPageLinkPickerButtonChanged
                  }, null, 8, ["payload", "errors", "onChanged"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}